import { Lumber, LumberWithStockLength } from '@paragon/contract-library';
import { distanceEquals } from '@paragon/geometry-library';

export function getLumberCodeExcludingSize(lumber: Lumber) {
  return [
    lumber.grade,
    lumber.tangibleGrades.toSorted().join(','),
    lumber.species,
    lumber.tangibleSpecies.toSorted().join(','),
    lumber.treatmentType,
  ].join('|');
}

export function getLumberCode(lumber: Lumber) {
  return `${lumber.actualThickness}x${lumber.actualWidth}|${getLumberCodeExcludingSize(lumber)}`;
}

export function lumbersAreEqual(lumber1: Lumber, lumber2: Lumber): boolean {
  return getLumberCode(lumber1) === getLumberCode(lumber2);
}

export function lumbersAreEqualExcludingSize(lumber1: Lumber, lumber2: Lumber): boolean {
  return getLumberCodeExcludingSize(lumber1) === getLumberCodeExcludingSize(lumber2);
}

export function lumbersWithStockLengthAreEqual(a: LumberWithStockLength, b: LumberWithStockLength) {
  return distanceEquals(a.stockLength, b.stockLength) && lumbersAreEqual(a, b);
}
